// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"31b58241","73":"16c28da5","204":"c139b912","555":"72e0b39b","859":"3941f483","991":"a46272cd"}[chunkId] + ".chunk.js";
};